import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, take, switchMap, catchError, map, filter } from 'rxjs/operators';

import * as fromStore from '../store';
import { of } from 'rxjs';
import { SetTitle, SetTags } from '../../store';
import { StringUtility } from '@teamfoster/sdk/text-utility';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { ImageSharpConfig, ResizePipe } from '@teamfoster/sdk/image';

export const NewsDetailMetaGuard: CanActivateFn = route => {
  const store = inject(Store);
  const lang = inject(LanguageService);
  const dict = new FromDictionaryPipe(lang);
  const resizeImage = new ResizePipe(ImageSharpConfig);

  return store
    .select(fromStore.getSelectedNews)
    .pipe(
      tap(page => {
        if (!page) {
          return;
        }
        store.dispatch(
          SetTitle({
            title: `${page?.title} ${dict.transform('meta-titel-suffix') ? '- ' + dict.transform('meta-titel-suffix') : ''}`,
          })
        );
        store.dispatch(
          SetTags({
            properties: {
              'description': StringUtility.Truncate(StringUtility.stripHtmlTags(page.intro), 157, '...'),
              'og:image': page.image?.url
                ? 'https:' + resizeImage.transform(page.image?.url, 1200, 630, page.image?.anchor || 'middlecenter')
                : '',
              'og:title': `${page.title} ${dict.transform('meta-titel-suffix')}`,
              'og:description': StringUtility.Truncate(StringUtility.stripHtmlTags(page.intro), 157, '...'),
            },
          })
        );
      }),
      filter(a => a?.id > 0),
      map(a => true),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};
